import { createConsola } from "consola";

export const logger = createConsola({
    level: parseInt(import.meta.env.VITE_APP_LOG_LEVEL as string),
});